import React, { useEffect, useState } from "react";
import { useInternet } from "../../../../../hooks/useInternet.js";
import { Button } from "../../../../../components/button.jsx";

export function SettingsIntegrationsPage() {
  let [apiKey, setApiKey] = useState("");
  let internet = useInternet();
  useEffect(() => {
    internet.get("/accounts/apikey").then(async (res) => {
      let { key } = await res.json();
      setApiKey(key);
    });
  }, []);

  let rotate = () => {
    return internet.post("/accounts/apikey/rotate").then(async (res) => {
      let { key } = await res.json();
      setApiKey(key);
    });
  };

  return (
    <div className={"flex flex-col gap-3 p-3"}>
      {" "}
      <div className={"flex"}>
        <h2 className={"font-bold py-2 flex items-center flex-grow"}>
          Integrations
        </h2>
      </div>
      <div style={{ maxWidth: 500 }} className={"flex flex-col gap-3"}>
        <p>
          Do you want to integrate Lancerkit with other tools? Check out our
          integration options below
        </p>
        <div className={"bg-white rounded p-3 flex flex-col gap-3"}>
          <h4 className={"font-medium"}>API</h4>
          <p>
            Use the following API key to integrate with tools supporting API
            connection, such as:
            <a href={"https://www.make.com/"} className={"underline"}>
              Make
            </a>
            ,{" "}
            <a href={"https://zapier.com/"} className={"underline"}>
              Zapier
            </a>
            ,{" "}
            <a href={"https://integrately.com/"} className={"underline"}>
              Integrately
            </a>
          </p>
          <div className={"bg bg-gray-800 rounded p-3 flex items-center"}>
            <pre className={"font-mono flex-grow text-white"}>{apiKey}</pre>
            <Button sizing={"s"} onClick={rotate}>
              Rotate
            </Button>
          </div>
        </div>
        <div className={"bg-white rounded p-3 flex flex-col gap-3"}>
          <h4 className={"font-medium"}>FTP</h4>
          <p>
            To integrate our tool with your FTP directory, please contact us at:
            <a href={"mailto:contact@lancerkit.com"} className={"underline"}>
              contact@lancerkit.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
